module.exports = __webpack_public_path__ + "static/ENmobSlide4-89632af48edb611b20d790e69bb79c56.jpg";